import React, {useState} from 'react';
import {Modal} from 'antd';
import "../../assets/css/Dentobook.css";
import "../../assets/css/PatientPhotos.css";
import {FormattedMessage} from "react-intl";
import {CloseOutlined} from '@ant-design/icons';
import {InvoiceResponse} from "../../api-client";
import {getInvoicesApi} from "../../api/apiInstances";
import logger from "../../utils/logger";

interface PatientInvoiceVoidModalProps {
    proforma: boolean;
    invoice: InvoiceResponse | undefined;
    loadData: Function;
    isModalOpen: boolean;
    setIsModalOpen: Function;
}

const PatientInvoiceVoidModal = ({
                                     proforma, invoice, loadData, isModalOpen, setIsModalOpen
                                 }: PatientInvoiceVoidModalProps) => {
    const [loading, setLoading] = useState<boolean>(false);

    const invoicesApi = getInvoicesApi();

    const handleCancel = () => {
        setIsModalOpen(false);
    }

    const handleOk = async () => {
        if (!invoice) {
            logger.log('invoice is undefined');

            return;
        }

        setLoading(true);
        invoicesApi.updateInvoice(invoice.id!, {...invoice, status: !proforma ? 'CANCELLED' : 'CANCELLED_PROFORMA'} as InvoiceResponse)
            .then(() => {
                setIsModalOpen(false);
                loadData();
            })
            .catch(err => logger.error(err))
            .finally(() => setLoading(false));
    }

    return (
        <Modal
            transitionName=""
            className={'dentobook-modal dentobook-small-modal'}
            okButtonProps={{
                className: "modal-btn danger-btn"
            }}
            cancelButtonProps={{
                className: "modal-btn"
            }}
            confirmLoading={loading}
            width={600}
            okText={<FormattedMessage id="void_button"/>}
            cancelText={<FormattedMessage id="cancel"/>}
            closeIcon={<CloseOutlined className={'icon-24px'} onClick={handleCancel}/>}
            open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
            <div style={{width: '100%', display: 'flex', justifyContent: 'center'}}>
                <h3 className="font-24 font-weight-500 text-center text-align-center" style={{width: !proforma ? 400 : 430}}>
                    <FormattedMessage id={!proforma ? "void_message" : "proforma_void_message"}/>
                </h3>
            </div>
        </Modal>
    );
};

export default PatientInvoiceVoidModal;